<template>
  <div class="d-flex align-center my-2 mr-3">
    <UrlAutocompleter
      :initial-urls="initialEntries"
      @changed="onChanged"
    />
    <v-switch
      v-model="include"
      class="ml-2"
      style="width: 150px; max-width: 150px;"
      :label="include
        ? $t('journal.search.filters.included')
        : $t('journal.search.filters.excluded')"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { criterias } from '../SearchCriteria';
import UrlAutocompleter from './UrlAutocomplete';

export default {
  name: 'UrlFilter',
  components: { UrlAutocompleter },
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    initialEntries: [],
    entries: [],
    isLoading: false,
    include: true,
    id: `${criterias.URL_FILTER}/${nanoid(10)}`,
    rules: [
      v => (v && v.length !== 0) || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.filters[0].Url;
      this.include = data.kind === 'Include';
      this.initialEntries = [...data.param];
    }
  },
  methods: {
    onChanged(event) {
      this.entries = [...event];
    },
    getCriteria() {
      return {
        filters: [
          {
            Url: {
              kind: this.include ? 'Include' : 'Exclude',
              param: this.entries,
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
